import { put, call, takeLatest } from 'redux-saga/effects'

import { getDocumentStats as getDocumentStatsApi } from 'Service/Api'

import * as StatsTypes from 'Redux/Types/StatsTypes'
import * as StatsActions from 'Redux/Actions/StatsActions'

function* getDocumentMonthlyStats({ payload }) {
  try {
    const { data } = yield call(getDocumentStatsApi, payload)
    yield put(StatsActions.getDocumentMonthlyStatsSucceeded(data))
  } catch (errors) {
    yield put(StatsActions.getDocumentMonthlyStatsFailed(errors))
  }
}

function* getDocumentWeeklyStats({ payload }) {
  try {
    const { data } = yield call(getDocumentStatsApi, payload)
    yield put(StatsActions.getDocumentWeeklyStatsSucceeded(data))
  } catch (errors) {
    yield put(StatsActions.getDocumentWeeklyStatsFailed(errors))
  }
}

export default function* statsSaga() {
  yield takeLatest(StatsTypes.GET_DOCUMENT_WEEKLY_STATS, getDocumentWeeklyStats)
  yield takeLatest(StatsTypes.GET_DOCUMENT_MONTHLY_STATS, getDocumentMonthlyStats)
}
